import { FC, useCallback } from "react"
import { Link } from "gatsby"

// components
import { ChoiceCard } from "../Marmalade/ChoiceCard/ChoiceCard"

// icons
import {
  CalendarIcon,
  ClipboardIcon,
  MegaphoneIcon,
  MoneyIcon,
  ReceiptIcon,
  TicketIcon,
  UserIcon
} from "@eventbrite/marmalade"

// utils
import { events } from "../../utils/heap/tracking_events"
import { handleUrlString } from "../../utils/seo/seo_utils"

// styles
import {
  iconContainer,
  iconWrapper
} from "../BrowseByTopicSection/Topic.module.scss"
import {
  topicCard,
  topicButton,
  topicCategoryLinkWrapper
} from "./Topic.module.scss"

export const icons = {
  TicketMulti: <TicketIcon size="medium" />,
  Money: <MoneyIcon size="medium" />,
  User: <UserIcon size="medium" />,
  CalendarAdd: <CalendarIcon size="medium" />,
  Megaphone: <MegaphoneIcon size="medium" />,
  ListView: <ReceiptIcon size="medium" />,
  Document: <ClipboardIcon size="medium" />
}
export const iconsSizedForCatSideNav = {
  TicketMulti: <TicketIcon size="small" />,
  Money: <MoneyIcon size="small" />,
  User: <UserIcon size="small" />,
  CalendarAdd: <CalendarIcon size="small" />,
  Megaphone: <MegaphoneIcon size="small" />,
  ListView: <ReceiptIcon size="small" />,
  Document: <ClipboardIcon size="small" />
}

export const findIcon = (iconName: string, iconArray: typeof icons) => {
  return iconArray[iconName]
}

export type SingleTopicItem = {
  node: SingleTopicContent
}

export type SingleTopicContent = {
  displayName?: string
  content?: SingleTopicContentObject[]
}

export type SingleTopicContentObject = {
  title: string
  iconName: string
  slug: string
}

export type Props = {
  topic: SingleTopicContentObject
  prefixedBasePath: string
}

const Topic: FC<Props> = ({ topic, prefixedBasePath }) => {
  const trackOnClick = useCallback(() => {
    events?.homepageBrowseByTopic(topic.title, Topic?.name)
  }, [topic])

  return (
    <Link
      to={handleUrlString(`${prefixedBasePath}/topics/${topic?.slug}`, {
        removePrefix: true
      })}
      onClick={trackOnClick}
      className={topicCategoryLinkWrapper}
    >
      <ChoiceCard testId={topic.title} wrapperButtonClassName={topicButton}>
        <div className={topicCard}>
          <div className={iconContainer}>
            <div className={iconWrapper}>{findIcon(topic.iconName, icons)}</div>
          </div>
          {topic?.title}
        </div>
      </ChoiceCard>
    </Link>
  )
}

export default Topic
